/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum SelectedFilterType {
	HAS_MEDIA = 'HasMedia',
	RATING = 'Rating',
	VERIFIED_PURCHASER = 'VerifiedPurchaser'
}

export enum OrderType {
	A1 = 'A1',
	ASC = 'asc',
	DESC = 'desc'
}

export enum  SortOptionKey {
	HIGHEST_RATED = 'highest-rated',
	LOWEST_RATED = 'lowest-rated',
	MOST_HELPFUL = 'most-helpful',
	MOST_RELEVANT = 'most-relevant',
	NEWEST = 'newest',
	OLDEST = 'oldest',
}

export enum SortType {
	HIGHEST_RATED = 'Rating',
	LOWEST_RATED = 'Rating',
	MOST_HELPFUL = 'Helpfulness',
	MOST_RELEVANT = 'relevancy',
	NEWEST = 'SubmissionTime',
	OLDEST = 'SubmissionTime'
}

export interface SelectedSortOption {
	order: OrderType,
	type: SortType
}

export interface SelectedFilter {
	name: string;
	value: string | boolean | number | string[] | number[];
}